<template>
  <Form :method="method"
        :action="action"
        :form-data="form"
        @success="success">
    <template v-slot="{ errors, submitting }">
      <h3 class="text-gray-400 mb-4">
        {{ customfield ? 'Wijzigen' : 'Eigen veld toevoegen' }}
      </h3>
      <div class="bg-gray-100 rounded py-3 px-3 mb-3">
        <div class="flex -mx-2">
          <BaseRadio name="type"
                     v-model="form.type"
                     value="text"
                     label="Tekstveld"
                     class="mx-2"
                     @change="focusName()" />
          <BaseRadio name="type"
                     v-model="form.type"
                     value="select"
                     label="Dropdown"
                     class="mx-2"
                     @change="focusName()" />
        </div>
      </div>
      <label class="block mb-3">
        <span class="block mb-1">Naam</span>
        <BaseInput name="name"
                   v-model="form.name"
                   :error="errors.name"
                   placeholder="Naam van het veld"
                   required
                   v-focus
                   ref="name" />
      </label>
      <div v-if="form.type == 'select'"
           class="mb-3">
        <label class="block mb-3">
          <span class="block mb-1">Opties <span class="text-gray-400 text-sm">(in de dropdown)</span></span>
          <input class="form-input w-full"
                 name="option"
                 v-model="option"
                 placeholder="Voeg hier opties toe"
                 @keydown.enter.prevent="addOption"
                 @blur="addOption" />
        </label>
        <div class="text-gray-400 mb-1">
          {{ form.options.length ? 'Toegevoegde opties:' : 'Nog geen optie toegevoegd' }}
        </div>
        <draggable v-model="form.options"
                   group="options"
                   ghost-class="bg-gray-200"
                   handle=".cursor-move">
          <div v-for="option in form.options"
               :key="option"
               class="bg-gray-100 rounded px-3 text-sm mb-1">
            <div class="flex items-center justify-between">
              <div class="flex-1 cursor-move py-1">
                {{ option }}
              </div>
              <button class="text-gray-400 hover:text-gray-900"
                      @click="removeOption(option)">
                <BaseIcon name="x"
                          size="14" />
              </button>
            </div>
          </div>
        </draggable>
      </div>
      <div class="flex py-3">
        <button type="submit"
                class="btn btn-blue"
                :disabled="submitting">Opslaan</button>
        <button type="button"
                class="cancel"
                @click="close">Annuleren</button>
      </div>
    </template>
  </Form>
</template>

<script>
import draggable from "vuedraggable";
import { focusFirstFormElement } from "@/functions.js";
import Form from "@/components/Form";

export default {
  inject: ["close"],

  props: {
    method: {
      type: String,
      default: "post"
    },
    action: {
      type: String,
      required: true
    },
    contactType: {
      default: "contact"
    },
    customfield: {
      type: Object
    }
  },

  components: {
    Form,
    draggable
  },

  data() {
    return {
      form: {
        contact_type: this.contactType,
        name: "",
        type: "text",
        options: []
      },
      option: ""
    };
  },

  created() {
    if (this.customfield) {
      this.form.name = this.customfield.name;
      this.form.type = this.customfield.type;
      this.form.options = [...this.customfield.options];
    }
  },

  methods: {
    addOption() {
      if (this.option && !this.form.options.includes(this.option)) {
        this.form.options.push(this.option);
        this.option = "";
      }
    },

    removeOption(option) {
      let index = this.form.options.findIndex(v => v === option);
      this.form.options.splice(index, 1);
    },

    focusName() {
      focusFirstFormElement(this.$refs.name);
    },

    success(data) {
      this.$store.commit("SET_SETTINGS", data);
      this.$store.commit("FLASH_ADD", { message: "Customveld is opgeslagen!" });
      this.close();
    }
  }
};
</script>
